<template>
  <v-container fluid class="bg-image">
    <v-row justify="start">
      <v-btn @click="$router.push('/login')" color="primary" text>
        <v-icon>mdi-chevron-left</v-icon>{{$t('go_back')}}
      </v-btn>
    </v-row>
    <v-row justify="center" class>
      <v-img :src="imageLogoUrlBlue" max-height="200px" contain aspect-ratio="1.7"></v-img>
    </v-row>
    <v-row align="center" justify="center">
      <v-card color="background" elevation="0" flat>
        <v-card-title primary-title class="py-0 pb-7 pt-4">
          <v-row justify="center">
            <span class="text-h5 font-weight-light primary--text">FORGOT PASSWORD</span>
          </v-row>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form @submit.prevent ref="forgot-password-form">
            <v-row justify="center">
              <v-col cols="12" md="8">
                <v-text-field
                  :rules="[required('Email'), email()]"
                  v-model="userEmail"
                  solo
                  flat
                  label="email"
                  @keypress.enter="requestPasswordReset"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pt-3">
          <v-row justify="center">
            <v-col cols="12" class="ma-0 pa-0 text-center">
              <v-btn
                @click="requestPasswordReset"
                class="py-6 px-11"
                large
                color="primary"
              >Recover Password</v-btn>
            </v-col>
            <v-col cols="12" class="ma-0 pt-5 text-center">
              <p
                class="primary--text font-weight-light"
              >An email will be sent for you to recover your password.</p>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { CONSUMERS_API } from '@/clients/consumers.api'
import { email, required } from '@/utils/validations'
export default {
  data () {
    return {
      userEmail: ''
    }
  },
  components: {

  },
  methods: {
    email,
    required,
    async requestPasswordReset () {
      if (!this.$refs['forgot-password-form'].validate()) {
        return
      }
      this.$spinner()
      let res
      try {
        res = await CONSUMERS_API.Auth.requestPasswordReset({ email: this.userEmail })
      } catch (e) {
        this.$spinner()
        return this.$snackbar({ text: Array.isArray(e.error.payload) ? e.error.payload.join(' | ') : e.error.msg, color: 'error', timeout: 7000 })
      }
      this.$refs['forgot-password-form'].resetValidation()
      this.$refs['forgot-password-form'].reset()
      this.$spinner()
      return this.$snackbar({ text: res.msg, icon: 'mdi-check-circle', color: 'success', timeout: 15000 })
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.bg-image {
  background: rgba($color: #f0f0f0, $alpha: 1);
  height: 100vh;
}
.transparent-card {
  background: rgba(255, 255, 255, 0);
}
a {
  text-decoration: underline;
}
</style>
